/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { CampaignType, TYPE_ICONS } from 'cio/models/campaign';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import AccountService from 'cio/services/account';

interface TriggerTypeSelectorArgs {
  selectedPreviewType: CampaignType;
  onChangeType: () => void;
  selectedType: CampaignType;
  resetSelectedType: () => void;
  triggerIsSaved: boolean;
}

export default class TriggerTypeSelector extends Component<TriggerTypeSelectorArgs> {
  @service account!: AccountService;
  @service facebookLeadAds!: FacebookLeadAdsService;

  CampaignType = CampaignType;

  get peopleTriggerTypes() {
    return [
      {
        id: CampaignType.Behavioral,
        icon: TYPE_ICONS[CampaignType.Behavioral],
        label: 'When a person moves in or out of a segment',
        description: 'Best for drip campaigns or personalized marketing',
      },
      {
        id: CampaignType.Transactional,
        icon: TYPE_ICONS[CampaignType.Transactional],
        label: 'When someone performs an event',
        description: 'Best for responding when a user does something in your product',
      },
      {
        id: CampaignType.Date,
        icon: TYPE_ICONS[CampaignType.Date],
        label: 'When a specific date occurs',
        description: 'Best for recurring events, like birthdays or subscription renewals',
      },
      {
        id: CampaignType.Form,
        icon: TYPE_ICONS[CampaignType.Form],
        label: 'When someone submits a form',
        description: 'Best for nurturing new leads or replying to user research surveys',
      },
      {
        id: CampaignType.Webhook,
        icon: TYPE_ICONS[CampaignType.Webhook],
        label: 'Create your own trigger from a webhook',
        description: 'Best for working with data from outside of your workspace',
      },
      {
        id: 'notSure',
        icon: 'help',
        label: "I'm not sure",
        description: 'Get help choosing or setting up a trigger type',
      },
    ];
  }
}
